<template>
  <div class="">
    <div v-if="showLoginForm">
      <div class="text-center text-base font-medium sm:text-lg pb-4" v-if="newUser">
        <p>You have signed up successfully</p>
        <p class="text-sm">Please enter your login details</p>
      </div>

      <!-- title -->
      <div v-else>
        <h1 class="text-center text-base font-medium sm:text-lg pb-4">Sign in to your account</h1>
      </div>

      <Alert v-if="formErrorMessage" variant="destructive" class="mb-3">
        <AlertDescription>{{ formErrorMessage }}</AlertDescription>
      </Alert>

      <form class="space-y-4" @submit.prevent>
        <!-- email input -->
        <div class="space-y-1">
          <Input
            id="emailInput"
            v-model="email"
            placeholder="Email"
            name="email"
            type="email"
            :class="errors.email ? 'border-destructive' : ''"
          />
          <p v-if="errors.email" class="text-xs text-destructive">{{ errors.email }}</p>
        </div>

        <!-- password input -->
        <div class="space-y-1">
          <Input
            id="passwordInput"
            v-model="password"
            placeholder="Password"
            name="password"
            type="password"
            :class="errors.password ? 'border-destructive' : ''"
          />
          <p v-if="errors.password" class="text-xs text-destructive">{{ errors.password }}</p>
        </div>

        <!-- forgot password link -->
        <div class="flex items-center justify-end pb-2">
          <router-link
            id="forgotPasswordButton"
            to="/auth/forgot-password"
            class="font-medium text-muted-foreground underline text-sm"
          >
            Forgot password
          </router-link>
        </div>

        <!-- sign in button -->
        <Button
          id="signInButton"
          type="submit"
          :disabled="disableSubmit"
          @click="signIn"
          size="lg"
          class="w-full h-10"
        >
          {{ loading ? 'Signing in...' : 'Sign in' }}
        </Button>
      </form>
    </div>
  </div>
</template>

<script>
import { Input, Button, Alert, AlertDescription } from '@boogi/ui'

export default {
  name: 'SignIn',
  components: {
    Input,
    Button,
    Alert,
    AlertDescription,
  },
  props: {
    backdoorKey: {
      type: String,
    },
  },
  data() {
    return {
      showLoginForm: true,
      newUser: this.$route.query.type == 'newUser',

      email: '',
      password: '',
      loading: false,
      errorMessage: undefined,
      formErrorMessage: '',
      errors: {
        type: Object,
        default: function () {
          return {
            email: '',
            password: '',
          }
        },
      },
    }
  },
  created() {},
  methods: {
    async loadUser() {
      try {
        const token = localStorage.getItem('token')
        const response = await this.$apiFetch(
          `${process.env.VUE_APP_API_URL}/private/api/client/user`,
          {
            method: 'GET',
            headers: { 'Content-Type': 'application/json', Authorization: `${token}` },
          }
        )
        if (response.ok) {
          const object = await response.json()
          const publisher = object.publisher
          localStorage.setItem('firstName', object.publisherUser.firstName)
          localStorage.setItem('lastName', object.publisherUser.lastName)
          localStorage.setItem('publisher', publisher.companyName)
          localStorage.setItem('publisherId', publisher.id)
          localStorage.setItem('publisherStatus', publisher.publisherStatus)
          localStorage.setItem('sandbox', publisher.sandboxOnly)
          // Seeds the topbar toggle. Kept separate from the URLs because dev points both
          // the production and sandbox env vars at the same host.
          localStorage.setItem('sandboxMode', String(!!publisher.sandboxOnly))
          localStorage.setItem('sendContentNotifications', object.publisherUser.sendContentNotifications)
          if (publisher.sandboxOnly) {
            localStorage.setItem('apiUrl', process.env.VUE_APP_SANDBOX_API_URL)
            localStorage.setItem('apiType', process.env.VUE_APP_SANDBOX_API_TYPE)
          } else {
            localStorage.setItem('apiUrl', process.env.VUE_APP_API_URL)
            localStorage.setItem('apiType', process.env.VUE_APP_API_TYPE)
          }
          this.$router.push('/')
        }
      } catch (error) {
        console.error(error)
      }
    },

    async signIn() {
      this.loading = true
      try {
        var body = {
          email: this.email,
          password: this.password,
        }

        const response = await this.$apiFetch(
          `${process.env.VUE_APP_API_URL}/private/api/client/auth/login`,
          {
            method: 'POST',
            body: JSON.stringify(body),
            headers: {
              'Content-Type': 'application/json',
            },
          }
        )

        if (response.ok) {
          var object = await response.json()

          if (object.status == 'MFA_REQUIRED') {
            sessionStorage.setItem(
              'mfaSession',
              JSON.stringify({
                session: object.session,
                email: this.email,
                type: 'MFA_CODE',
              })
            )
            this.$router.push('/auth/two-factor')
          }
          if (object.status == 'MFA_SETUP') {
            sessionStorage.setItem(
              'mfaSession',
              JSON.stringify({
                session: object.session,
                email: this.email,
                type: 'MFA_SETUP',
                qrCodeValue: object.qrcodeData || object.QRCodeData || object.qRCodeData,
              })
            )
            this.$router.push('/auth/two-factor')
          }
          if (object.status == 'COMPLETED') {
            localStorage.setItem('token', 'Bearer ' + object.idToken)
            await this.loadUser()
          }
        } else {
          this.formErrorMessage = 'Incorrect email or password'
        }
      } catch (error) {
        this.formErrorMessage = 'Incorrect email or password'
        return
      } finally {
        this.loading = false
      }
    },
  },
  computed: {
    disableSubmit: function () {
      if (this.email.length < 1) return true
      if (this.password.length < 1) return true
      return false
    },
    signinData: function () {
      return {
        email: this.email,
        password: this.password,
      }
    },
    tokenSame: function () {
      return this.mfaToken == this.mfaTokenCreation
    },
  },
  mounted() {
    document.title = 'Boogi Dashboard | Sign in'
  },
  watch: {
    email: function (value) {
      this.email = value.toLowerCase()
      this.formErrorMessage = ''
    },
    password: function () {
      this.formErrorMessage = ''
    },
  },
}
</script>

<style></style>
